import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import {
  ITEM_MAX_PHOTOS_TOTAL,
} from '../storage/client-item-limits';
import { CabinetPhotoUploaderComponent } from './cabinet-photo-uploader.component';

@Component({
  selector: 'lib-item-media-uploader',
  imports: [CabinetPhotoUploaderComponent],
  template: `
    <lib-cabinet-photo-uploader
      entityType="item"
      [entityId]="itemId()"
      [maxFiles]="maxPhotos()"
      accept="image/jpeg,image/png,image/webp"
      listAriaLabel="CLIENT.CABINET.MEDIA.ITEM_LIST_LABEL"
      emptyTitleKey="CLIENT.CABINET.MEDIA.ITEM_EMPTY_TITLE"
      emptyHintKey="CLIENT.CABINET.MEDIA.STAFF_ITEM_EMPTY_HINT"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemMediaUploaderComponent {
  readonly itemId = input.required<string>();
  readonly maxPhotos = input(ITEM_MAX_PHOTOS_TOTAL);

  readonly uploader = viewChild(CabinetPhotoUploaderComponent);

  uploadAll(): Promise<void> {
    return this.uploader()?.uploadAll() ?? Promise.resolve();
  }

  successfulMediaIds(): string[] {
    return this.uploader()?.successfulMediaIds() ?? [];
  }
}
